"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEntityId = void 0;
const getEntityId = (source) => {
    if (!source)
        return;
    if (typeof source === 'string')
        return source;
    if (source.id)
        return source.id.toString();
    if (source._id)
        return source._id.toString();
};
exports.getEntityId = getEntityId;
//# sourceMappingURL=get-entity-id.js.map